import { Component, Input, Inject, Output, EventEmitter } from "@angular/core";

import { ServiceConfig } from "../../../core/core.constants";
import { PersonDataService } from "../../../core/persons.dataservice";
import { ILogService, IPromise } from "angular";

@Component({
    selector: "crew-person-details",
    template: require('./person.details.component.html'),
    styles: [require('../../../shared/label-button.css')]
})

export class PersonDetailsComponent {
    @Input()
    person: Nema.Crew.Model.Person;

    @Input()
    dateOfBirth: Date;

    @Output()
    dateOfBirthChange: EventEmitter<Date> = new EventEmitter<Date>();

    onDateOfBirthChange(d: Date) {
        this.dateOfBirthChange.emit(d);
    }

    @Input()
    isReadonly: boolean;

    constructor(
        @Inject(PersonDataService.Id) private personDataService: PersonDataService,
        @Inject("$log") private $log: ILogService) {
        this.syncNokFromHr = true;
    }

    webApiUrl: string = ServiceConfig.webApiUrl;

    @Input()
    syncNokFromHr: boolean;

    handleFileInput(_file: File[]): IPromise<any> {
        if (!_file || _file.length === 0) {
            console.warn("No file present!");
            return;
        }

        return this.personDataService
            .savePersonImage(_file[0], this.person.Id)
            .then(() => {
                this.$log.info("Successfully saved person image");
                this.reloadPage();
            })
            .catch(err => this.$log.error("Could not save person image, error occured: " + err));
    }

    deleteImage(): IPromise<any> {
        if (!this.person.ImageFileRv) {
            return;
        }

        return this.personDataService
            .deletePersonImage(this.person.Id)
            .then(() => {
                this.$log.info("Successfully deleted person image");
                this.reloadPage();
            })
            .catch(err => this.$log.error("Could not delete person image, error occured: " + err));
    }

    reloadPage() {
        window.location.reload(true);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/details/person.details.component.ts